import React, { useState } from "react";
import { Layout, Menu, Breadcrumb } from "antd";
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const { Content, Sider } = Layout;

const graphs = [
  {
    id: "graph1",
    title: "Evolución en el tiempo",
    menuTitle: "Evolución en el tiempo",
    text: `En 2025, 1,5 de cada 1.000 niñas y niños denunciaron ser víctimas de violencia intrafamiliar. El peak de denuncias se observa en el año 2011, con una progresiva 
          caída hasta 2017. A partir del año 2018 se observa una pequeña alza y estabilización de las denuncias por violencia intrafamiliar para el año 2018 y 2019. En 2020, 
          con la llegada de la pandemia, hubo una caída abrupta en las cifras, atribuida en parte al cierre de las escuelas, pasando en 2019 de un 1,9 a un 1,3 en 2020. 
          Establecimientos de salud y educativos son un canal fundamental para la detección y denuncia de casos de violencia intrafamiliar, lo que explica la disminución de 
          los registros durante ese período. En 2021, con la reapertura parcial de las actividades pospandemia, se observó un incremento en las denuncias, aunque las cifras 
          siguieron siendo inferiores a las registradas antes de la pandemia.`,
    link: "https://public.flourish.studio/visualisation/20924323/embed",
  },
  {
    id: "graph2",
    title: "Análisis por sexo",
    menuTitle: "\u2022 Sexo",
    text: `Históricamente, las niñas presentan mayores tasas de denuncia por violencia intrafamiliar que los niños. En 2025, por cada 1,8 niñas que denunciaron ser víctimas 
          de violencia intrafamiliar, 1,3 niños realizaron la misma denuncia.`,
    link: "https://public.flourish.studio/visualisation/20924343/embed",
  },
  {
    id: "graph3",
    title: "Análisis por edad",
    menuTitle: "\u2022 Edad",
    text: `Al observar las tasas de denuncia por violencia intrafamiliar de acuerdo al tramo etario, es evidente que adolescentes entre 14 y 17 años presentan la tasa más alta 
          de victimización por delitos de violencia intrafamiliar. En 2025, 2,8 de cada 1.000 niñas y niños mayores de 14 años denunciaron violencia, mientras que entre menores 
          de 14 años, sólo 1,1 de cada 1.000 presentó una denuncia.`,
    link: "https://public.flourish.studio/visualisation/20924360/embed",
  }
  /*
  {
    id: "graph4",
    title: "Análisis por región",
    menuTitle: "\u2022 Región",
    text: `La tasa de denuncia intrafamiliar varía de acuerdo a la región en que habitan niñas y niños, sin embargo se observa para casi todas las regiones un peak en el 
    año 2011 y una caída en 2020. La región que en 2024 tuvo una mayor tasa de denuncia fue Aysén, con un 3,4, y la que tuvo una menor tasa fue Magallanes, con 0,7 niñas 
    o niños cada 1.000.`,
    link: "https://public.flourish.studio/visualisation/20924370/embed",
  }
  */
];


const App = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [selectedMenuItem, setSelectedMenuItem] = useState("graph1");

  const handleMenuItemClick = (graphId) => {
    setSelectedMenuItem(graphId);
  };

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const selectedGraph = graphs.find((graph) => graph.id === selectedMenuItem);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider
        width={250}
        collapsible
        collapsed={collapsed}
        onCollapse={toggleCollapsed}
        style={{ background: "#fff" }}
        breakpoint="lg"
        collapsedWidth={0}
      >
        <Menu
          theme="dark"
          mode="vertical"
          selectedKeys={[selectedMenuItem]}
          style={{ background: "#fff" }}
        >
          {graphs.map((graph) => (
            <Menu.Item
              key={graph.id}
              onClick={() => handleMenuItemClick(graph.id)}
              style={{
                color: "black",
                paddingLeft: graph.id !== "graph1" ? "30px" : "20px",
              }}
            >
              {graph.menuTitle}
            </Menu.Item>
          ))}
        </Menu>
      </Sider>
      <Layout style={{ padding: "24px 24px 24px" }}>
        <Breadcrumb style={{ margin: "16px 0" }}>
          <Breadcrumb.Item></Breadcrumb.Item>
        </Breadcrumb>
        <Content
          id="content"
          style={{
            background: "#ffff",
            padding: 24,
            margin: 0,
            minHeight: 280,
          }}
        >
          {selectedGraph && (
            <div>
              <div style={{ marginBottom: 16 }}>
                <h1>{selectedGraph.title}</h1>
              </div>
              <div style={{ textAlign: 'justify' }}>
                <ReactMarkdown remarkPlugins={[remarkGfm]}>
                  {selectedGraph.text}
                </ReactMarkdown>
              </div>
              {selectedGraph.link && (
                <iframe
                  src={selectedGraph.link}
                  frameBorder="0"
                  scrolling="no"
                  style={{ minWidth: "100%", height: "500px" }}
                ></iframe>
              )}
            </div>
          )}
        </Content>
      </Layout>
    </Layout>
  );
};

export default App;